import { makeRequest } from 'utils/requestLogger';

export default () =>
    makeRequest('get', '/api/users/validate-school-membership');


// WEBPACK FOOTER //
// ./src/app/services/account/validateSchoolMembership.js